// function isDefined (v) {
//   return v !== undefined && v !== null
// }

class Param {
  constructor (f = {}, s = {}) {
    let key = f instanceof Object ? f.key || s.by : s.by
    if (key) {
      let value = f.value === undefined ? '' : f.value
      let fn = f.f || s.f
      if (fn instanceof Function) {
        value = fn(value) || ''
      }
      if (typeof value === 'number') {
        value = value + ''
      }
      if (typeof value !== 'string' && !(value instanceof Array)) {
        console.warn('[SearchParam] value should be String or Array, value: ', value)
        value = ''
      }
      this.key = key
      this.value = value
      this.descending = s.descending || false
      this.precious = f.precious || false
      this.range = f.range
    }
    else {
      throw TypeError('must set key')
    }
  }

  transform () {
    let key = this.key
    let value =this.descending ? {
      'order':  'DESC',
      operators: []
    }:{
      operators: []
    }
    let v = this.value
    if (this.range && v instanceof Array) {
      let r1 = v instanceof Array ? v[0] : -Infinity
      let r2 = v instanceof Array ? v[1] : -Infinity
      if (r1 !== undefined) {
        value.operators.push({
          keyword: r1,
          operator: 'GTE'
        })
      }
      if (r2 !== undefined) {
        value.operators.push({
          keyword: r2,
          operator: 'LTE'
        })
      }
    }
    else if (this.value instanceof Array) {
      value.operators.push({
        keyword: this.value.join(','),
        operator: 'IN'
      })
    }
    else {
      let o = {
        keyword: this.value === undefined ? '' : this.value,
        operator: 'LIKE'
      }
      if (this.precious) {
        if (typeof this.precious === 'string') {
          let map = {
            'BOTH': 'BOTH',
            'ALL': 'BOTH',
            'LEFT': 'PREFIX',
            'SUFFIX': 'SUFFIX',
            'PREFIX': 'PREFIX',
            'RIGHT': 'SUFFIX'
          }
          o.matchType = map[this.precious.toUpperCase()] || 'NONE'
        }
        else {
          o.matchType = 'NONE'
        }
      }
      value.operators.push(o)
    }
    // if (v === '' || v === undefined || v === null) {
    //
    // }

    return {key, value}
  }
}

class SearchParam {
  constructor (pagination, sortStack, filter, search) {
    this.paramList = []

    // 排序栈 这里最后入栈的为最优先关键字
    let sortStack_ = sortStack instanceof Array ? sortStack.splice(0) : []
    let search_ = search
    let filter_ = {}

    // 处理filter的两种情况
    if (filter instanceof Array) {
      filter.forEach(f => {
        if (f.key) {
          filter_[f.key] = f
        }
      })
    }
    else if (filter instanceof Object) {
      for (let key of Object.keys(filter)) {
        let value = filter[key]
        if (value instanceof Object) {
          filter_[key] = value
        }
        else if (typeof value === 'string') {
          filter_[key] = {key: key, value: value}
        }
      }
    }

    // 处理分页排序关键字不在sortStack的情况
    let sortBy = pagination.sortBy || ''
    let descending = pagination.descending || false
    if (sortBy) {
      let t = sortStack_.find(s => s.by === sortBy)
      // 如果在排序里找到，直接重写
      if (t) {
        descending = pagination.descending || t.descending || false
        let i = sortStack_.indexOf(t)
        sortStack_.splice(i, 1)
      }
      sortStack_.push({by: sortBy, descending: descending})
    }

    // 取相反顺序开始遍历
    sortStack_.reverse()

    // 优先合成排序字段
    // forEach保证按顺序执行
    sortStack_.forEach(s => {
      // result[s.by] = toSearchParam(filter_[s.by], i + 1, s)
      this.paramList.push(new Param(filter_[s.by], s))
    })

    // searchParam index字段值
    // let idx = Object.keys(result).length + 1

    // 将search字段的值补入
    if (search_ instanceof Object && search_.key) {
      this.paramList.push(new Param(search_))
    }

    // 在filter中筛选没有排序的字段加入searchParam
    for (let key of Object.keys(filter_)) {
      this.paramList.push(new Param(filter_[key]))
    }
  }

  static merge (target, source) {
    // console.log('merge', Object.assign({}, target), Object.assign({}, source))
    if (!(target.operators instanceof Array)) {
      target.operators = []
    }
    if (!(source.operators instanceof Array)) {
      source.operators = []
    }
    for (let opt of source.operators) {
      let t = target.operators.find(o => o.keyword === opt.keyword)
      if (t) {
        if (t.operator === opt.operator) {
          if (opt.precious) {
            opt.precious = true
          }
        }
        else {
          target.operators.push(opt)
        }
      }
      else {
        target.operators.push(opt)
      }
    }
    return target
  }

  create () {
    let result = {}
    let idx = 0
    this.paramList.forEach(param => {
      let {key, value} = param.transform()
      // console.log('param', key, Object.assign({}, value))
      if (result[key]) {
        result[key] = SearchParam.merge(result[key], value)
      }
      else {
        value.index = idx
        idx++
        result[key] = value
      }
    })
    // console.log('result', result)
    let checkOpr = ['creationTime', 'LastUpdateTime']
    checkOpr.forEach(key => {
      if (result[key]) {
        let d = []
        let s = result[key].operators || []
        s.forEach((opr, i) => {
          if (['GT', 'LT', 'GTE', 'LTE'].indexOf(opr.operator) < 0) {
            d.unshift(i)
          }
        })
        d.forEach(idx => {
          s.splice(idx, 1)
        })
      }
    })

    return result
  }
}

export {SearchParam}
